import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Button } from "@ui/button";
import { ExternalLinkIcon } from "lucide-react";
import { CodonSequence } from "./CodonSequence";

type AuthSplashScreenProps = {
  showSignIn: boolean;
};

export function AuthSplashScreen({ showSignIn }: AuthSplashScreenProps) {
  const { login } = useKindeAuth();

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-8 overflow-y-auto bg-background py-12">
      <h1 className="font-semibold text-3xl">Gnomux</h1>

      <CodonSequence />

      <p className="max-w-md text-center text-muted-foreground">
        A browser-based workbench for managing, annotating, and analyzing DNA
        sequences.
      </p>

      <p className="text-center text-muted-foreground text-sm">
        Currently in private beta.{" "}
        <a
          href="https://tally.so/r/RGlojj"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 underline hover:text-foreground"
        >
          Request access
          <ExternalLinkIcon className="size-3.5" />
        </a>
      </p>

      {showSignIn && (
        <Button
          onClick={() =>
            login({ orgCode: import.meta.env.VITE_KINDE_ORG_CODE })
          }
        >
          Sign in
        </Button>
      )}
      <div className="fixed bottom-4 left-4 flex items-center gap-3 text-muted-foreground text-xs">
        <span>&copy; 2026 In Silico Industries Inc.</span>
        <a href="/privacy" className="underline hover:text-foreground">
          Privacy Policy
        </a>
      </div>
    </div>
  );
}
